import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import loadData from "../data";
import ErrorBoundary from "@Components/ErrorBoundary";
import usePropertyPage from "../usePropertyPage";

const PropertyPage = loadable(() => import("./PropertyPageDesktop"), {
  fallback: <FullPageLoader />,
});

const NotFound = loadable(() => import("@Pages/NotFound"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isError, showFullPageLoader, isLoading, isStatus500 } = usePropertyPage(props);

  if (isError) {
    return <NotFound isStatus500={isStatus500} {...props} />;
  }

  if (showFullPageLoader) {
    return <FullPageLoader />;
  }
  return (
    <ErrorBoundary>
      <PropertyPage isLoading={isLoading} />
    </ErrorBoundary>
  );
};
export { PropertyPage as PreFetchPropertyPage };
export { loadData };
